import { applyMiddleware, combineReducers, createStore } from "redux";
import { apiMiddleware } from "redux-api-middleware";
import thunk from "redux-thunk";
import userReducer from "./user/userReducer";
import translationsReducer from "./translationsReducer";

const createStoreWithMiddleware = applyMiddleware(
  thunk,
  apiMiddleware
)(createStore);

const reducer = combineReducers({
  user: userReducer,
  translations: translationsReducer
});

let initStateTranslations = [];
let initStateUser = null;

const initNodeUser = document.getElementById("init-state-user");
if (initNodeUser) {
  initStateUser = JSON.parse(initNodeUser.innerText);
}

const initNodeTranslations = document.getElementById("init-state-translations");
let language = "en";
if (initNodeTranslations) {
  initStateTranslations = JSON.parse(initNodeTranslations.innerText);

  language = initStateTranslations.locale;

  if (initStateTranslations.locale == "cz") {
    initStateTranslations.locale = "cs";
  }
  if (initStateTranslations.locale == "dk") {
    initStateTranslations.locale = "da";
  }
}

export const i18nConfig = initStateTranslations;

const store = createStoreWithMiddleware(
  reducer,
  {
    user: { ...initStateUser, language },
    translations: initStateTranslations
  },
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;
